import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../Icon/Icon';
import { useTranslation } from 'react-i18next';

const DEBOUNCE_MS = 400;

export default function Search({ value = '', onChange }) {
    const { t } = useTranslation();
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => setLocalValue(value), [value]);

    useEffect(() => {
        const id = setTimeout(() => onChange?.(localValue.trim()), DEBOUNCE_MS);
        return () => clearTimeout(id);
    }, [localValue, onChange]);

    return (
        <div className="flex-1">
            <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Icon
                        name="search"
                        fixedWidth
                        className="text-gray-500"
                    />
                </div>
                <input
                    value={localValue}
                    onChange={(e) =>
                        setLocalValue(e.target.value.replace(/\s+/g, ' '))
                    }
                    autoComplete="off"
                    type="search"
                    className="focus:ring-0 focus:outline-none block pl-7 pr-12 sm:text-sm border-gray-300 rounded-md ml-1"
                    placeholder={t(
                        'sections.campaigns.new-campaign.wizard-screens.filters.search'
                    )}
                />
            </div>
        </div>
    );
}

Search.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
